module.exports = __webpack_public_path__ + "img/yxzl_banner.079e2b0e.png";